import { type ComponentProps } from 'react';
import { Platform } from 'react-native';
import { TextInput } from 'react-native-paper';

import { useAppTheme } from '@/theme';

type Props = ComponentProps<typeof TextInput>;

const AppTextInputBase = (props: Props) => {
  const theme = useAppTheme();
  const defaults =
    Platform.OS === 'ios'
      ? { selectionColor: theme.colors.textNdPrimary }
      : {
          selectionColor: theme.colors.bgInfoWeakest,
          cursorColor: theme.colors.textNdPrimary,
          selectionHandleColor: theme.colors.textNdMuted,
        };
  return <TextInput {...defaults} {...props} />;
};

export const AppTextInput = Object.assign(AppTextInputBase, {
  Icon: TextInput.Icon,
  Affix: TextInput.Affix,
});
